import React from 'react';
import SVGComponent from '../../components/SVG/SVGComponent';
import { LIVE_SCORE_STATUS, PERMISSIONS, SVG_ICONS } from '../../constants';
import StatusDropdown from './StatusDropdown';

const LiveScoreStatusTable = ({
  liveScoreList, competitions, selectedBtnStatus,
  toggleEnableDisableBtn, toggleStatusDropdown, selectedDropdown,
  handleStatusDropdown, closeBtnConfirmation, confirmBtnStatus, checkPermisson,
}) => liveScoreList.map((liveScore) => {
  const competitionName = competitions
    .find((comp) => comp.id === liveScore.competitionId)?.name;
  return (
    <tr
      key={liveScore.competitionId}
      className={`table-style__row
      ${selectedBtnStatus === liveScore.competitionId && 'edit-feed'}`}
    >
      <td>
        {competitionName}
      </td>
      <td>
        <span className="feed-status">{LIVE_SCORE_STATUS[liveScore.status]}</span>
        <StatusDropdown
          liveScore={liveScore}
          selectedDropdown={selectedDropdown}
          toggleDropDown={toggleStatusDropdown}
          handleStatusDropdown={handleStatusDropdown}
        />
      </td>
      <td>
        {checkPermisson(PERMISSIONS.TENNIS_LIVE_SCORE_STATUS_UPDATE)
          && (
            <div className="d-flex justify-content-center">

              <div
                className="option-btn option-btn--feed"
                onClick={toggleEnableDisableBtn.bind(this, liveScore.competitionId)}
                disabled={(selectedBtnStatus !== null && selectedBtnStatus !== liveScore.competitionId)}
              >
                <span>
                  Enable/Disable
                  <br />
                  Status
                </span>
              </div>

              <div className="action">
                <div className="action-wrap">
                  <div
                    className="action__btn action__btn--approve"
                    onClick={confirmBtnStatus.bind(this, liveScore.competitionId)}
                  >
                    <SVGComponent
                      src={`${SVG_ICONS.utility}#tick1`}
                    />
                  </div>
                  <div
                    onClick={closeBtnConfirmation.bind(this, liveScore.competitionId)}
                    className="action__btn action__btn--cancel"
                  >
                    <SVGComponent
                      src={`${SVG_ICONS.utility}#close-w`}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
      </td>
    </tr>
  );
});
export default LiveScoreStatusTable;
